import round from 'lodash/round';
import { type MarketCartTotalsCartSummaryI } from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';

/**
 * The credit that brings a cart's whole-cycle `cost` down to the amount due for a
 * partial first billing period. Negative when the cart is prorated, `null` when it
 * is not, so callers can hide the line item.
 */
const getProratedAdjustment = (cart?: MarketCartTotalsCartSummaryI) => {
	if (!cart || cart.cost - cart.prorated_cost <= 0) {
		return null;
	}

	return round(cart.prorated_cost - cart.cost, 2);
};

export default getProratedAdjustment;
